import { render, staticRenderFns } from "./Vita.vue?vue&type=template&id=b94a3394&scoped=true&"
import script from "./Vita.vue?vue&type=script&lang=js&"
export * from "./Vita.vue?vue&type=script&lang=js&"
import style0 from "./Vita.vue?vue&type=style&index=0&id=b94a3394&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94a3394",
  null
  
)

export default component.exports